import { DAIMI_TR_INTRO, DAIMI_TR_SLUG } from '@/content/daimiTurkiye'
import { LABS_EYEBROW, cover, pdf } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The fifth report with a designed page of its own — asked for on 2026-08-27,
  // *"daimi türkiye özel"*, with two thumbnails of the live page and three
  // figures. See `content/daimiTurkiye.ts` and `pages/DaimiTurkiye.tsx`. The
  // index card still reads this entry's cover and title.
  slug: DAIMI_TR_SLUG,
  title: 'Türkiye Dijital ve Yapay Zeka Olgunluk Raporu 2026',
  eyebrow: LABS_EYEBROW,
  headline: 'Türkiye Dijital ve Yapay Zeka Olgunluk Raporu 2026',
  cover: cover(
    'daimi-raporu-2026-turkiye-cover',
    'Türkiye Dijital ve Yapay Zeka Olgunluk Raporu 2026',
  ),
  // The page's own opening paragraph, so the search result and the page agree —
  // `prerender.tsx` takes the meta description from `body[0]`. It used to be the
  // series description in English, which is what `stillToCome({ copy: true })`
  // said out loud. It is Turkish now because the page is: the document sits
  // under `/en/` like every report, and `pages/DaimiTurkiye.tsx` marks the words
  // `lang="tr"` where they are.
  body: DAIMI_TR_INTRO.body,
  // The bucket key folds the "ü" — the bucket rejects a Turkish object key
  // outright, so the file it holds is "Turkiye…" while the report is not.
  //
  // The uuid is the bucket's, and it is the one thing here that cannot be
  // derived or guessed: the key carried `…-cc9d-4c2c-b9f3-9b7cf1a5b4e1-` until
  // 2026-09-15, which shares only its first group with the real object and so
  // answered 400 on every click while the file sat in the bucket perfectly
  // intact. Copy it from the upload dialog, never retype it.
  download: pdf('ba242da7-ecc0-4353-9d33-f4eb66944c75-Turkiye Dijital ve Yapay Zeka Olgunluk Raporu 2026.pdf'),
  layout: 'turkiye-edition',
  // Nothing left for `stillToCome` to say: file, cover and its own words. What
  // is still open about it is section-by-section on its page, and
  // `daimiTurkiyeChecks()` carries that into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 2
